import { EditorState, convertFromRaw } from "draft-js"

interface Comment {
	message: string
}

export default function getTextFromComment(comment: Comment): string {
	const jsonifiedCommentMessage = JSON.parse(comment.message)
	const messageConvertedFromRaw = convertFromRaw(jsonifiedCommentMessage)
	const tempEditorState = EditorState.createWithContent(messageConvertedFromRaw)
	const commentText = tempEditorState.getCurrentContent().getPlainText("\u0001")
	return commentText.replace("\u0001", " ")
}
